import TabPage from '@/components/TabPage';

export default function TeamExecution() {
  return <TabPage chartFullKeys={['visit_intensity']} />;
}
